var winW = window.innerWidth;
var zoom;
if(winW <= 576){
  zoom = 12;
} else if (winW <= 768) {
  zoom = 12.5;
} else {
  zoom = 13.25;
}


//13.25


// mapbox scripts
mapboxgl.accessToken = 'pk.eyJ1IjoiYnBkYXZpczgxIiwiYSI6ImNrcTQwbDR4NTByZGgycG56N3pkMDB1NGMifQ.5qgmUy3sOAsi5vEhcV3Rmg';

// create map
var map = new mapboxgl.Map({
  container: 'map',
  style: 'mapbox://styles/bpdavis81/ckprhl1da2m3o18oa8b0dl0kb',
  zoom: zoom,
  pitch: 45,
  center: [-104.804, 39.883]
});
var nav = new mapboxgl.NavigationControl();
map.addControl(nav, 'bottom-right');


map.on('load', function(){
  // Create Layers
  map.addSource('builders', {
    type: 'vector',
    url:  'mapbox://bpdavis81.ckq2qq4a701h321k9bb8fepcf-0ifv8'
  });
  map.addSource('recreation', {
    type: 'vector',
    url:  'mapbox://bpdavis81.ckq2t806904v821ppyhx2yyke-2auei'
  });
  map.addSource('coffee', {
    type: 'vector',
    url:  'mapbox://bpdavis81.ckq2tbfnf04q620ppyi927rsz-5vh4z'
  });
  map.addSource('stand', {
    type: 'vector',
    url:  'mapbox://bpdavis81.ckq2tecv20kbe21pgned4a3ka-2e84y'
  });
  map.addSource('parks', {
    type: 'vector',
    url:  'mapbox://bpdavis81.ckq2ti90k02ew29k9vr9ktlqh-1oli6'
  });
  map.addSource('southlawn', {
    type: 'vector',
    url:  'mapbox://bpdavis81.ckq2tngxj0iaz21w4f0bl9eh1-8sfkr'
  });
  map.addSource('golf', {
    type: 'vector',
    url:  'mapbox://bpdavis81.ckq2tpr6a0d7428nw4zbicl76-1cbv0'
  });
  map.addSource('schools', {
    type: 'vector',
    url:  'mapbox://bpdavis81.ckq2tu36i0d8v28nwk6rokl88-1ufkp'
  });
  map.addSource('shopping', {
    type: 'vector',
    url:  'mapbox://bpdavis81.ckq2u72e80guq27w4x1afgyc7-1yk2a'
  });

  // Add Layers
  map.addLayer({
    'id':     'home builders',
    'type':   'symbol',
    'source': 'builders',
    'layout': {
      'visibility': 'visible',
      'icon-image': [
        'match',
        ['get','builder'],
        'Oakwood Homes',
        'oakwood-icon',
        'Tri Pointe Homes',
        'tripointe-icon',
        'Richmond American Homes',
        'richmond-icon',
        /* other */
        'builder-icon',
      ],
      'icon-size':  1,
      'icon-allow-overlap': true
    },
    'source-layer': 'Reunion_-_Homebuilders'
  });
  map.addLayer({
    'id':     'reunion rec center',
    'type':   'symbol',
    'source': 'recreation',
    'layout': {
      'visibility': 'none',
      'icon-image': 'pool-icon',
      'icon-size':  1,
      'icon-allow-overlap': true
    },
    'source-layer': 'Reunion_-_Rec_Center'
  });
  map.addLayer({
    'id':     'reunion coffee house',
    'type':   'symbol',
    'source': 'coffee',
    'layout': {
      'visibility': 'none',
      'icon-image': 'coffee-icon',
      'icon-size':  1,
      'icon-allow-overlap': true
    },
    'source-layer': 'Reunion_-_Coffee_House'
  });
  map.addLayer({
    'id':     'reunion concession stand',
    'type':   'symbol',
    'source': 'stand',
    'layout': {
      'visibility': 'none',
      'icon-image': 'stand-icon',
      'icon-size':  1,
      'icon-allow-overlap': true
    },
    'source-layer': 'Reunion_-_Concession'
  });
  map.addLayer({
    'id':     'parks and trails',
    'type':   'symbol',
    'source': 'parks',
    'layout': {
      'visibility': 'none',
      'icon-image': 'park-icon',
      'icon-size':  1,
      'icon-allow-overlap': true
    },
    'source-layer': 'Reunion_-_Parks'
  });
  map.addLayer({
    'id':     'southlawn pool',
    'type':   'symbol',
    'source': 'southlawn',
    'layout': {
      'visibility': 'none',
      'icon-image': 'pool-icon',
      'icon-size':  1,
      'icon-allow-overlap': true
    },
    'source-layer': 'Reunion_-_Southlawn'
  });
  map.addLayer({
    'id':     'golf',
    'type':   'symbol',
    'source': 'golf',
    'layout': {
      'visibility': 'none',
      'icon-image': 'golf-icon',
      'icon-size':  1,
      'icon-allow-overlap': true
    },
    'source-layer': 'Reunion_-_Golf'
  });
  map.addLayer({
    'id':     'schools',
    'type':   'symbol',
    'source': 'schools',
    'layout': {
      'visibility': 'none',
      'icon-image': 'school-icon',
      'icon-size':  1,
      'icon-allow-overlap': true
    },
    'source-layer': 'Reunion_-_Schools'
  });
  map.addLayer({
    'id':     'shopping',
    'type':   'symbol',
    'source': 'shopping',
    'layout': {
      'visibility': 'none',
      'icon-image': 'shopping-icon',
      'icon-size':  1,
      'icon-allow-overlap': true
    },
    'source-layer': 'Reunion_-_Shopping'
  });
});

// Layer IDs
var toggleLayerIds = ['home builders','reunion rec center','reunion coffee house','reunion concession stand','parks and trails','southlawn pool','golf','schools','shopping'];


// Create Buttons
for(var i = 0; i < toggleLayerIds.length; i++){
  var id = toggleLayerIds[i];
  var link = document.createElement('a');
  link.href = '#';

  if(id === 'home builders'){
    link.className = 'active menu-link';
  } else {
    link.className = 'menu-link';
  }
  link.id = id.replace(/\s+/g,'-') + '-btn';
  link.textContent = id;


  link.onclick = function(e) {
    var clickedLayer = this.textContent;

    e.preventDefault();
    e.stopPropagation();

    for(var j = 0; j < toggleLayerIds.length; j++){
      if(clickedLayer === toggleLayerIds[j]){
        layers.children[j].className = 'menu-link active';
        map.setLayoutProperty(toggleLayerIds[j], 'visibility', 'visible');
      } else {
        layers.children[j].className = 'menu-link';
        map.setLayoutProperty(toggleLayerIds[j], 'visibility', 'none');
      }
    }
  };
  var layers = document.getElementById('menu');
  layers.appendChild(link);
}

// Show Popup on Builder Icon Click
map.on('click', function(e){
  var builders = map.queryRenderedFeatures(e.point, {
    layers: ['home builders']
  });
  if(!builders.length){ return; }
  var builder = builders[0];

	console.log(builder);

  // Define Builder Data
  var builderName = builder.properties.builder;
  var collection =  builder.properties.collection;
  var address =     builder.properties.address;
  var phone =       builder.properties.phone;
  var price =       builder.properties.price;
  var footage =     builder.properties.square_footage;
  var bed =         builder.properties.beds;
  var bath =        builder.properties.bath;
  var image =       builder.properties.image;
  var url =         builder.properties.url;

  var builderPopup = new mapboxgl.Popup({offset: [0,25]})
    .setLngLat(builder.geometry.coordinates)
    .setHTML(
      '<div class="builder-popup popup">' +
        '<picture class="popup-image"><img src="' + image + '" class="img-fluid" alt="' + builderName + '" /></picture>' +
        '<div class="builder-details">' +
          '<h2 class="blue-txt builder-name">' + builderName + '</h2>' +
          '<h3 class="gold-txt builder-collection">' + collection + '</h3>' +
          '<p class="builder-address">' + address + '<br/>' + phone + '</p>' +
          '<div class="builder-models">' +
            '<p>' +
              '<strong class="gold-txt">' + price + '</strong><br />' +
              '<span class="model-details">' + footage + ' sq. ft. | ' + bed + ' bedrooms <br/>' + bath + ' bathrooms</span>' +
            '</p>' +
          '</div>' +
          '<p class="button-container">' +
            '<a href="' + url + '" class="btn gold-btn">View Homes</a>' +
          '</p>' +
      '</div>'
    )
    .addTo(map);
});



// Show Popup on Icon clickedLayer
map.on('click', function(e){
  var features = map.queryRenderedFeatures(e.point, {
    layers: ['reunion rec center','reunion coffee house','reunion concession stand','parks and trails','southlawn pool','golf','schools','shopping']
  });
  if(!features.length){return; }
  var feature = features[0];

  console.log(feature);

  // Define Data Fields
  var title =   feature.properties.title;
  var address = feature.properties.address;
  var phone =   feature.properties.phone;
  var url =     feature.properties.url;
  var image =   feature.properties.image;
  var description = feature.properties.description;

  var mapPopupContent = '<div class="popup">' +
    '<picture class="popup-image"><img src="' + image + '" class="img-fluid" alt="' + title + '" /></picture>' +
    '<div class="builder-details">' +
      '<h2 class="blue-txt builder-name">' + title + '</h2>';

    if(address) {
      mapPopupContent += '<p class="builder-address">' + address;
    }
    if(phone){
      mapPopupContent += '<br />' + phone + '</p>';
    } else {
      mapPopupContent += '</p>';
    }
    if(description){
      mapPopupContent += '<p class="builder-address">' + description + '</p>';
    }
    if(url){
      mapPopupContent += '<p class="button-container">' +
        '<a href="' + url + '" class="btn gold-btn">More Info</a>' +
      '</p>';
    }

    '</div>' + //close popup .builder-details
    '</div>'; // close popup container

  var mapPopup = new mapboxgl.Popup({offset: [0,25]})
    .setLngLat(feature.geometry.coordinates)
    .setHTML(mapPopupContent)
    .addTo(map);
});

// Functions to show/hide sidebar content
$(document).ready(function(){
  $('.menu-link').click(function(){
    var target = $(this).attr('id');
    target = target.substring(0, target.length - 4);

    $('.map-category').removeClass('active');
    $('#' + target).addClass('active');
  });
});
